export interface OmanProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface OmanFactory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: OmanProduct[];
}

export const omanFactories: OmanFactory[] = [
  {
    id: "of1",
    name: "Muscat Frankincense & Oud Co.",
    city: "Muscat",
    established: 2006,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Oman", "UAE", "Saudi Arabia", "UK", "France", "USA"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 460,
    categories: ["Fragrance", "Luxury", "Beauty"],
    description: "Oman's premier frankincense and oud producer, sourcing the finest Hojari frankincense directly from Dhofar. Supplying luxury resins, oils, and bakhoor to global retailers and dropshippers.",
    logo: "https://public.readdy.ai/ai/img_res/17d1a04d8de4e4a1df905f78ca19d3d2.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Muscat%20Oman%20frankincense%20oud%20factory%20production%20luxury%20fragrance%20resin%20bottles%20elegant%20interior%20professional%20bright%20clean&width=800&height=400&seq=ofc1&orientation=landscape",
    products: [
      {
        id: "of1p1",
        name: "Hojari Frankincense Premium Resin 500g",
        samplePrice: 85,
        bulkPrice: 30,
        moq: 20,
        category: "Fragrance",
        image: "https://readdy.ai/api/search-image?query=Hojari%20frankincense%20premium%20resin%20500g%20luxury%20Oman%20white%20background%20product%20photography%20gold%20packaging%20elegant&width=400&height=400&seq=of1p1&orientation=squarish",
      },
      {
        id: "of1p2",
        name: "Omani Oud Pure Oil 12ml",
        samplePrice: 130,
        bulkPrice: 52,
        moq: 12,
        category: "Fragrance",
        image: "https://readdy.ai/api/search-image?query=Omani%20oud%20pure%20oil%2012ml%20luxury%20Arabic%20perfume%20bottle%20gold%20elegant%20white%20background%20product%20photography%20premium&width=400&height=400&seq=of1p2&orientation=squarish",
      },
      {
        id: "of1p3",
        name: "Dhofar Bakhoor Gift Set",
        samplePrice: 72,
        bulkPrice: 26,
        moq: 24,
        category: "Beauty",
        image: "https://readdy.ai/api/search-image?query=Dhofar%20bakhoor%20gift%20set%20luxury%20Oman%20gold%20packaging%20elegant%20white%20background%20product%20photography%20premium%20Middle%20East&width=400&height=400&seq=of1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "of2",
    name: "Sohar Industrial Steel Works",
    city: "Sohar",
    established: 2003,
    employees: "500–1000",
    verified: true,
    dropshipping: false,
    rating: 4.7,
    responseRate: "93%",
    onTimeDelivery: "94%",
    productCount: 830,
    categories: ["Steel", "Construction", "Industrial"],
    description: "Heavy-duty steel and metal fabrication plant in Sohar Industrial Port. Producing structural steel, pipes, and custom metal works for construction and oil & gas industries worldwide.",
    logo: "https://readdy.ai/api/search-image?query=steel%20industrial%20company%20logo%20gold%20metal%20emblem%20white%20background%20Sohar%20Oman%20corporate%20identity%20professional%20minimalist&width=80&height=80&seq=ofl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Sohar%20Oman%20industrial%20steel%20factory%20production%20workers%20welding%20metal%20construction%20professional%20bright%20modern%20interior&width=800&height=400&seq=ofc2&orientation=landscape",
    products: [
      {
        id: "of2p1",
        name: "Galvanized Steel Pipes Bundle (10pcs)",
        samplePrice: 220,
        bulkPrice: 85,
        moq: 10,
        category: "Steel",
        image: "https://readdy.ai/api/search-image?query=galvanized%20steel%20pipes%20bundle%2010pcs%20industrial%20construction%20material%20white%20background%20product%20photography%20professional%20metal&width=400&height=400&seq=of2p1&orientation=squarish",
      },
      {
        id: "of2p2",
        name: "Structural Steel H-Beams (6m)",
        samplePrice: 420,
        bulkPrice: 160,
        moq: 5,
        category: "Construction",
        image: "https://readdy.ai/api/search-image?query=structural%20steel%20H-beams%206m%20construction%20material%20white%20background%20product%20photography%20professional%20industrial%20metal%20building&width=400&height=400&seq=of2p2&orientation=squarish",
      },
      {
        id: "of2p3",
        name: "Custom Metal Fabrication Parts Set",
        samplePrice: 280,
        bulkPrice: 105,
        moq: 8,
        category: "Industrial",
        image: "https://readdy.ai/api/search-image?query=custom%20metal%20fabrication%20parts%20set%20industrial%20precision%20white%20background%20product%20photography%20professional%20manufacturing%20Oman&width=400&height=400&seq=of2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "of3",
    name: "Nizwa Dates & Honey Farm",
    city: "Nizwa",
    established: 2010,
    employees: "50–100",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Oman", "UAE", "Saudi Arabia", "UK", "Germany", "Malaysia"],
    rating: 4.9,
    responseRate: "96%",
    onTimeDelivery: "95%",
    productCount: 310,
    categories: ["Food & Beverage", "Agriculture", "Gift Sets"],
    description: "Premium Omani date and honey producer from the historic Nizwa region. Exporting award-winning Fardh dates and pure Sidr honey to global markets with halal certification and dropshipping.",
    logo: "https://readdy.ai/api/search-image?query=date%20honey%20farm%20company%20logo%20gold%20palm%20tree%20emblem%20white%20background%20Nizwa%20Oman%20corporate%20identity%20elegant%20minimalist&width=80&height=80&seq=ofl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Nizwa%20Oman%20date%20farm%20palm%20trees%20harvest%20honey%20production%20packaging%20professional%20bright%20clean%20traditional&width=800&height=400&seq=ofc3&orientation=landscape",
    products: [
      {
        id: "of3p1",
        name: "Omani Fardh Dates Premium Box 1kg",
        samplePrice: 58,
        bulkPrice: 20,
        moq: 24,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=Omani%20Fardh%20dates%20premium%20box%201kg%20luxury%20gold%20packaging%20white%20background%20product%20photography%20elegant%20food%20gift&width=400&height=400&seq=of3p1&orientation=squarish",
      },
      {
        id: "of3p2",
        name: "Pure Omani Sidr Honey 500g",
        samplePrice: 75,
        bulkPrice: 28,
        moq: 20,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=pure%20Omani%20Sidr%20honey%20500g%20luxury%20gold%20jar%20white%20background%20product%20photography%20premium%20natural%20food&width=400&height=400&seq=of3p2&orientation=squarish",
      },
      {
        id: "of3p3",
        name: "Oman Dates & Honey Gift Hamper",
        samplePrice: 95,
        bulkPrice: 38,
        moq: 15,
        category: "Gift Sets",
        image: "https://readdy.ai/api/search-image?query=Oman%20dates%20honey%20gift%20hamper%20luxury%20gold%20packaging%20elegant%20white%20background%20product%20photography%20premium%20corporate%20gift&width=400&height=400&seq=of3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "of4",
    name: "Ruwi Textile & Craft Factory",
    city: "Ruwi, Muscat",
    established: 2013,
    employees: "50–100",
    verified: false,
    dropshipping: true,
    warehouseCountries: ["Oman", "UAE", "India", "Turkey"],
    rating: 4.4,
    responseRate: "86%",
    onTimeDelivery: "88%",
    productCount: 270,
    categories: ["Textiles", "Clothing", "Handicrafts"],
    description: "Traditional Omani textile and handicraft manufacturer in Ruwi. Producing authentic Omani kumas, dishdasha fabrics, and handwoven crafts for global buyers and dropshippers.",
    logo: "https://readdy.ai/api/search-image?query=textile%20craft%20company%20logo%20gold%20weave%20emblem%20white%20background%20Ruwi%20Muscat%20Oman%20fabric%20manufacturing%20corporate%20identity&width=80&height=80&seq=ofl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Ruwi%20Muscat%20Oman%20textile%20craft%20factory%20traditional%20weaving%20sewing%20machines%20workers%20clothing%20production%20professional%20bright&width=800&height=400&seq=ofc4&orientation=landscape",
    products: [
      {
        id: "of4p1",
        name: "Traditional Omani Dishdasha Fabric (5m)",
        samplePrice: 65,
        bulkPrice: 24,
        moq: 20,
        category: "Textiles",
        image: "https://readdy.ai/api/search-image?query=traditional%20Omani%20dishdasha%20fabric%205m%20white%20elegant%20textile%20material%20white%20background%20product%20photography%20luxury%20Middle%20East&width=400&height=400&seq=of4p1&orientation=squarish",
      },
      {
        id: "of4p2",
        name: "Handwoven Omani Kuma Cap",
        samplePrice: 28,
        bulkPrice: 10,
        moq: 50,
        category: "Clothing",
        image: "https://readdy.ai/api/search-image?query=handwoven%20Omani%20kuma%20cap%20traditional%20embroidered%20white%20background%20product%20photography%20premium%20clothing%20Middle%20East%20craft&width=400&height=400&seq=of4p2&orientation=squarish",
      },
      {
        id: "of4p3",
        name: "Omani Silver Khanjar Replica (Decorative)",
        samplePrice: 95,
        bulkPrice: 38,
        moq: 10,
        category: "Handicrafts",
        image: "https://readdy.ai/api/search-image?query=Omani%20silver%20khanjar%20replica%20decorative%20traditional%20dagger%20white%20background%20product%20photography%20premium%20craft%20Middle%20East&width=400&height=400&seq=of4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "of5",
    name: "Salalah Coconut & Tropical Foods",
    city: "Salalah",
    established: 2015,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Oman", "UAE", "Saudi Arabia", "UK", "USA", "India"],
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "94%",
    productCount: 340,
    categories: ["Food & Beverage", "Agriculture", "Organic"],
    description: "Unique tropical food producer from Salalah, Oman's lush southern region. Exporting organic coconut products, tropical fruits, and specialty foods with halal certification and global dropshipping.",
    logo: "https://readdy.ai/api/search-image?query=tropical%20food%20company%20logo%20gold%20coconut%20palm%20emblem%20white%20background%20Salalah%20Oman%20organic%20corporate%20identity%20elegant&width=80&height=80&seq=ofl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Salalah%20Oman%20tropical%20food%20factory%20coconut%20products%20organic%20production%20professional%20bright%20clean%20modern%20interior%20lush%20green&width=800&height=400&seq=ofc5&orientation=landscape",
    products: [
      {
        id: "of5p1",
        name: "Organic Coconut Oil Cold-Pressed 1L",
        samplePrice: 32,
        bulkPrice: 12,
        moq: 50,
        category: "Organic",
        image: "https://readdy.ai/api/search-image?query=organic%20coconut%20oil%20cold%20pressed%201L%20premium%20glass%20bottle%20white%20background%20product%20photography%20professional%20clean%20natural%20food&width=400&height=400&seq=of5p1&orientation=squarish",
      },
      {
        id: "of5p2",
        name: "Salalah Dried Tropical Fruit Mix 500g",
        samplePrice: 28,
        bulkPrice: 10,
        moq: 40,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=Salalah%20dried%20tropical%20fruit%20mix%20500g%20premium%20packaging%20white%20background%20product%20photography%20professional%20clean%20food%20Oman&width=400&height=400&seq=of5p2&orientation=squarish",
      },
      {
        id: "of5p3",
        name: "Omani Rose Water Premium 250ml",
        samplePrice: 22,
        bulkPrice: 8,
        moq: 60,
        category: "Organic",
        image: "https://readdy.ai/api/search-image?query=Omani%20rose%20water%20premium%20250ml%20elegant%20glass%20bottle%20white%20background%20product%20photography%20luxury%20natural%20beauty%20food&width=400&height=400&seq=of5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "of6",
    name: "Muscat Smart Tech Industries",
    city: "Muscat",
    established: 2019,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Oman", "UAE", "Saudi Arabia", "UK", "USA", "Germany"],
    rating: 4.7,
    responseRate: "94%",
    onTimeDelivery: "93%",
    productCount: 420,
    categories: ["Electronics", "Smart Home", "IoT"],
    description: "Emerging smart technology manufacturer in Muscat producing IoT devices, smart home systems, and consumer electronics for global markets with full dropshipping support.",
    logo: "https://readdy.ai/api/search-image?query=smart%20tech%20company%20logo%20gold%20circuit%20wave%20emblem%20white%20background%20Muscat%20Oman%20technology%20corporate%20identity%20modern%20minimalist&width=80&height=80&seq=ofl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Muscat%20Oman%20smart%20tech%20factory%20clean%20room%20production%20IoT%20devices%20electronics%20professional%20bright%20modern%20interior&width=800&height=400&seq=ofc6&orientation=landscape",
    products: [
      {
        id: "of6p1",
        name: "Smart Solar Energy Monitor",
        samplePrice: 95,
        bulkPrice: 38,
        moq: 20,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=smart%20solar%20energy%20monitor%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20IoT%20home%20device&width=400&height=400&seq=of6p1&orientation=squarish",
      },
      {
        id: "of6p2",
        name: "WiFi Smart Thermostat",
        samplePrice: 68,
        bulkPrice: 26,
        moq: 30,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=WiFi%20smart%20thermostat%20modern%20sleek%20round%20design%20white%20background%20product%20photography%20professional%20tech%20home%20device&width=400&height=400&seq=of6p2&orientation=squarish",
      },
      {
        id: "of6p3",
        name: "Portable Solar Power Bank 20000mAh",
        samplePrice: 55,
        bulkPrice: 20,
        moq: 40,
        category: "Electronics",
        image: "https://readdy.ai/api/search-image?query=portable%20solar%20power%20bank%2020000mAh%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20electronics&width=400&height=400&seq=of6p3&orientation=squarish",
      },
    ],
  },
];
